import { Inject, Injectable } from '@angular/core';

import { Api } from '../api/api';
import { environment } from '../environment';
import { ESRI } from '../esri-loader-util';
import { IExportParameters, LogLevel } from '../types';

import { ILoggingService } from './interfaces/ILoggingService';
import { ToSqlStringService } from './to-sql-string.service';

let Geoprocessor: __esri.GeoprocessorConstructor;
@Injectable({ providedIn: 'root' })
export class ExportService {
    constructor(
        private readonly api: Api,
        private readonly toSqlStringService: ToSqlStringService,
        @Inject('LoggingService') public loggingService: ILoggingService
    ) {}

    public async exportToShapeFileAndOpenUrl(exportParams) {
        const result = await this.exportToShapeFile(exportParams);
        if (result) {
            window.open(result.value.url, '_blank');
        }
    }

    public async exportToShapeFile(exportParams) {
        const params = {
            Table: exportParams.tables ? exportParams.tables.map(t => `${t.owner}.${t.name}`).join(',') : 'SKIP',
            Filter: this.toSqlStringService.getSql(exportParams.query, exportParams.columns),
            Output_name: exportParams.name.replace(/[\\*/:<>?|\"%]/gi, ' '),
            Geometries: exportParams.geometries ? exportParams.geometries : ''
        };

        if (!Geoprocessor) {
            Geoprocessor = await ESRI.Geoprocessor;
        }

        const url = environment.ags.baseUrl + environment.ags.exportEndpoint;
        const gp = new Geoprocessor({url});
        const jobInfo = await gp.submitJob(params);
        if (jobInfo.jobStatus === 'job-failed') {
            this.loggingService.Log('export shapefile job failed', jobInfo.messages, LogLevel.Error);
            return;
        }

        await gp.waitForJobCompletion(jobInfo.jobId);
        return gp.getResultData(jobInfo.jobId, 'Output_File_Path');
    }

    public async exportToExcelAndOpenUrl(exportParams: IExportParameters) {
        const fileUrl = await this.exportToExcel(exportParams);
        window.open(fileUrl, '_blank');
    }

    public async exportToExcel(exportParams: IExportParameters) {
        const filename = await this.api.http2.post('export/excel', exportParams, { responseType: 'text' });
        return [this.api.http2.url, 'export/file/', filename].join('');
    }
}
